import { memo, ReactElement, useMemo } from "react";
import classNames from "classnames";
import { Document, Page, pdfjs } from "react-pdf";
import { TecorienLoader } from "../../ui";

import styles from "./style.module.scss";

// pdfjs.GlobalWorkerOptions.workerSrc = "pdf.worker.min.js";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export type PdfDocumentProps = {
  url: string
  width?: number
  height?: number
  scale?: number
  loading?: string | ReactElement
  noData?: string | ReactElement
  error?: string | ReactElement
  className?: string,
  documentClassName?: string,
}

export const PdfDocument = memo<PdfDocumentProps>((
  {
    url,
    className,
    loading = <TecorienLoader />,
    noData,
    error,
    height,
    width,
    scale,
    documentClassName,
  }) => {
  const documentStyle = useMemo(() => {
    if (width || height) {
      return {
        width,
        height,
      };
    }
    return undefined;
  }, [ width, height ]);

  return (
    <div
      className={classNames(styles.root, className)}
      style={documentStyle}
    >
      <Document
        className={documentClassName}
        file={url}
        loading={loading}
        noData={noData}
        error={error}
        renderMode="canvas"
      >
        <a
          href={url}
          target="_black"
          rel="noreferrer noopener"
        >
          <Page
            width={width}
            height={height}
            scale={scale}
            className={styles.page}
            renderAnnotationLayer={false}
            renderTextLayer={false}
            pageNumber={1}
          />
        </a>
      </Document>
    </div>

  );
});

export default PdfDocument;
